import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "owa-headers-refresh-token", webpackPrefetch: true */ './lazyIndex')
);

export const lazyGetAndUpdateRefreshToken = new LazyAction(
    lazyModule,
    m => m.getAndUpdateRefreshToken
);
